<template>
    <!-- Progressbar -->

    <div>
        <!-- Mobile -->
        <div class="mobile" v-if="isMobile">
            <!-- Mobile: Progressbar -->
            <div class="step-bar">
            <span class="complete">
                <span class="bar" :class="{'active': isProductSelection}"></span>
                <span class="bar" :class="{'active': isRefinement}"></span>
                <span class="bar" :class="{'active': isCustomization}"></span>
            </span>
            </div>

            <!-- Mobile: Step Number -->
            <div class="step-number">
                <span class="text step-number__item">Schritt </span>
                <span class="current step-number__item">{{ $route.meta.step }}</span>
                <span class="total step-number__item">/ 3</span>
            </div>
        </div>

        <!--/Mobile -->

        <!-- Default -->
        <div class="steps__header" v-if="isDefault">
            <div class="steps__header__step steps__header__step--one" :class="{'active': isProductSelection}">
                <a href="/gastro_geschirr_produkte/#panel-113-0-0-0" title="zurück zur Produktauswahl">
                    <span>Schritt 1:</span>
                    <span>Produkt ändern</span>
                </a>
            </div>


            <div class="arrow">
                <svg height="10" viewBox="0 0 20 10" width="20" xmlns="http://www.w3.org/2000/svg">
                    <path d="m19.7558333 4.40916667-3.9816666-3.98166667c-.2383286-.2382566-.5966972-.30951825-.9080455-.18056498s-.5143826.43273507-.5144545.76973165v2.52333333c0 .11505932-.093274.20833333-.2083334.20833333h-12.8933333c-.69035592.00000002-1.24999996.55964408-1.24999996 1.25 0 .69035593.55964404 1.24999998 1.24999996 1.25h12.8933333c.1150594 0 .2083334.09327401.2083334.20833334v2.52333333c.0000719.33699658.2031062.64077838.5144545.76973165s.6697169.05769161.9080455-.18056498l3.9816666-3.98166667c.3253183-.32541654.3253183-.85291679 0-1.17833333z"
                          fill="#dcb47d" fill-rule="evenodd"/>
                </svg>
            </div>

            <!-- Default: Step 2 -->
            <div class="steps__header__step steps__header__step--two" :class="{'active': isRefinement}">
                <template v-if="!isRefinement">
                    <router-link :to="{name: 'refinement'}">
                        <span>Schritt 2:</span>
                        <span>Design wählen</span>
                    </router-link>
                </template>

                <template v-if="isRefinement">
                    <span>Schritt 2:</span>
                    <span>Design wählen</span>
                </template>
            </div>

            <div class="arrow">
                <svg height="10" viewBox="0 0 20 10" width="20" xmlns="http://www.w3.org/2000/svg">
                    <path d="m19.7558333 4.40916667-3.9816666-3.98166667c-.2383286-.2382566-.5966972-.30951825-.9080455-.18056498s-.5143826.43273507-.5144545.76973165v2.52333333c0 .11505932-.093274.20833333-.2083334.20833333h-12.8933333c-.69035592.00000002-1.24999996.55964408-1.24999996 1.25 0 .69035593.55964404 1.24999998 1.24999996 1.25h12.8933333c.1150594 0 .2083334.09327401.2083334.20833334v2.52333333c.0000719.33699658.2031062.64077838.5144545.76973165s.6697169.05769161.9080455-.18056498l3.9816666-3.98166667c.3253183-.32541654.3253183-.85291679 0-1.17833333z"
                          fill="#dcb47d" fill-rule="evenodd"/>
                </svg>
            </div>

            <!-- Default: Step 3 -->
            <div class="steps__header__step steps__header__step--three" :class="{'active': isCustomization}">
                <template v-if="!isCustomization">
                    <router-link :to="{name: 'customizationType'}">
                        <span>Schritt 3:</span>
                        <span>Personalisieren</span>
                    </router-link>
                </template>
                <template v-if="isCustomization">
                    <span>Schritt 3:</span>
                    <span>Personalisieren</span>
                </template>
            </div>
        </div>

        <!--/Default -->
    </div>
</template>

<script>
    export default {
        name:     "ProgressBar",
        props:    {
            'type': {
                type:    String,
                default: 'default'
            }
        },
        computed: {
            /**
             * Checks if we have to render the mobile layout
             * @returns {boolean}
             */
            isMobile: function () {
                return this.type === 'mobile'
            },

            /**
             * Checks if we have to render the default layout
             * @returns {boolean}
             */
            isDefault: function () {
                return this.type === 'default'
            },

            /**
             * Checks if we're at the product selection step (1)
             * @returns {boolean}
             */
            isProductSelection: function () {
                return this.$route.name === 'productselection'
            },

            /**
             * Checks if we're at the refinement step (2)
             * @returns {boolean}
             */
            isRefinement: function () {
                return this.$route.name === 'refinement'
            },

            /**
             * Checks if we're at the customizationType step (3)
             * @returns {boolean}
             */
            isCustomization: function () {
                return this.$route.name === 'customizationType'
            },

            /**
             * Returns the step number of the current route, taken from its meta data.
             * @returns {number}
             */
            step: function () {
                return this.$route.meta.step;
            }
        }
    }
</script>
